import { useUser } from "hooks/use-user";
import { useEffect } from "react";
import { CHECK_INTERVAL, IDLE_TIMEOUT } from "utils/constant";

function IdleManager() {
  const channel = new BroadcastChannel("activityChannel");
  const user = useUser();
  console.log("User in IdleManager:", user);
  useEffect(() => {
    console.log("IdleManager initialized.", user?.Roles);
    if (user?.Roles !== "CC Dashboard") {
      console.log("IdleManager inactive for non-CC Dashboard users.");
      let lastActivity = Date.now();

      const updateActivity = () => {
        lastActivity = Date.now();
        channel.postMessage({ type: "USER_ACTIVITY", timestamp: lastActivity });
      };

      const checkIdleState = () => {
        const now = Date.now();
        const allTabsIdle = now - lastActivity >= IDLE_TIMEOUT;

        if (allTabsIdle) {
          // Notify all tabs and parent app
          channel.postMessage({ type: "ALL_TABS_IDLE" });
        }
      };

      // Track user activity
      window.addEventListener("mousemove", updateActivity);
      window.addEventListener("keypress", updateActivity);
      window.addEventListener("click", updateActivity);

      // Broadcast initial activity state
      updateActivity();

      // Periodically check idle state
      const interval = setInterval(checkIdleState, CHECK_INTERVAL);

      // Handle broadcast messages
      channel.onmessage = (event) => {
        if (event.data.type === "USER_ACTIVITY") {
          lastActivity = Math.max(lastActivity, event.data.timestamp);
        }
      };

      return () => {
        clearInterval(interval);
        window.removeEventListener("mousemove", updateActivity);
        window.removeEventListener("keypress", updateActivity);
        window.removeEventListener("click", updateActivity);
        channel.close();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return null;
}

export default IdleManager;

// import { useUser } from "hooks/use-user";
// import { useEffect } from "react";
// import { CHECK_INTERVAL, IDLE_TIMEOUT } from "utils/constant";

// function IdleManager() {
//   const channel = new BroadcastChannel("activityChannel");
//   const user = useUser();

//   useEffect(() => {
//     if (user?.Roles !== "CC Dashboard") {
//       let lastActivity = Date.now();

//       const updateActivity = () => {
//         lastActivity = Date.now();
//         channel.postMessage({ type: "USER_ACTIVITY", timestamp: lastActivity });
//       };

//       const checkIdleState = () => {
//         const now = Date.now();
//         const allTabsIdle = now - lastActivity >= IDLE_TIMEOUT;

//         if (allTabsIdle) {
//           // Notify all tabs and parent app
//           channel.postMessage({ type: "ALL_TABS_IDLE" });
//         }
//       };

//       // Track user activity
//       window.addEventListener("mousemove", updateActivity);
//       window.addEventListener("keypress", updateActivity);
//       window.addEventListener("click", updateActivity);

//       // Broadcast initial activity state
//       updateActivity();

//       // Periodically check idle state
//       const interval = setInterval(checkIdleState, CHECK_INTERVAL);

//       // Handle broadcast messages
//       channel.onmessage = (event) => {
//         if (event.data.type === "USER_ACTIVITY") {
//           lastActivity = Math.max(lastActivity, event.data.timestamp);
//         }
//       };

//       return () => {
//         clearInterval(interval);
//         window.removeEventListener("mousemove", updateActivity);
//         window.removeEventListener("keypress", updateActivity);
//         window.removeEventListener("click", updateActivity);
//         channel.close();
//       };
//     }
//   }, [user]);

//   return null;
// }

// export default IdleManager;
